import moment from "moment";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";

const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const DeniedRequisition = () => {
  // const {user}=useAuth()
  const [limit, setLimit] = useState(50);

  const [pageIndex, setPageIndex] = useState(0);
  const [search, setSearch] = useState("");
  //  get Denied Requisition
  const {
    data: deniedRequisition,
    error: error1,
    mutate,
  } = useSWR(
    `store/requisition/denied/all?page=${pageIndex}&limit=${limit}`,
    fetcher1
  );
  console.log(deniedRequisition);

  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
    let limit = search === "" ? 10 : 1000;
    const res = await API.get(
      `store/requisition/denied/all?page=${0}&limit=${limit}`,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("data not found");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate([], false);
    }
  };

  let count = 1;
  return (
    <>
      <Helmet>
        <title>Done Requisition - BBA STORE</title>
        <meta name="description" content="View Requisition - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              All Denied Requisition List
            </h3>
          </div>

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div">
              <div className="col-12 col-md-4 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries
                  <select
                    onClick={(e) => {
                      setLimit(parseInt(e.target.value));
                    }}
                    className="ms-2 btn-outline-color "
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </p>
              </div>

              <div className="col-12 col-md-4 col-lg-4">
                <input
                  className="p-2 input-field_store w-100"
                  type="text"
                  name="Search"
                  onChange={(e) => handleSearch(e)}
                  placeholder="Search Requisitions"
                />
              </div>
            </div>
            {!deniedRequisition ? (
              <NotFoundPage />
            ) : (
              <div className="table-responsive-sm data-table">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr
                     className="tableColor"
                    >
                      <th>S/N</th>
                      <th>Date </th>
                      <th>Time </th>
                      <th>Name</th>
                      <th>Designation</th>
                      <th>Department</th>
                      <th>Remarks</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {deniedRequisition.map((product) => (
                      <tr key={count}>
                        <th className="text-center">{count++}</th>
                        <td>
                          {moment(new Date(product.REQUIDATE)).format(
                            "DD-MM-YYYY"
                          )}
                        </td>
                        <td>{product.DENYTIME}</td>
                        <td>{product.NAME_ENGLISH}</td>
                        <td>{product.DESIGNATION}</td>
                        <td>{product.DEPARTEMENT}</td>
                        <td>{product.DENYREMARKS}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {search.length > 0 ? (
              <div></div>
            ) : (
              <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {deniedRequisition && deniedRequisition.length === limit ? (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DeniedRequisition;
